import { ComponentStyle } from '@/theme/styles.types';

export const labelStyles: ComponentStyle = {
	default: 'text-sm font-medium text-neutral-800'
};

export const headingStyles: ComponentStyle = {
	default: '__heading __typography antialiased relative leading-snug',
	states: {
		normal: 'text-neutral-800',
		invert: 'text-white',
		withSubheading: 'mb-1'
	},
	variants: {
		h1: 'text-2xl font-bold',
		h2: 'text-xl font-bold',
		h3: 'text-lg font-bold',
		h4: 'text-base font-bold',
		h5: 'text-base font-bold',
		h6: 'text-sm  font-bold'
	}
};

export const highlightStyles: ComponentStyle = {
	default: '__highlight_typography px-2 leading-normal pb-1 rounded',
	variants: {
		primary: 'bg-primary-600 text-white',
		success: 'bg-success-600 text-white',
		error: 'bg-error-600 text-white',
		warning: 'bg-warning-500 text-neutral-800'
	}
};

export const underlineStyles: ComponentStyle = {
	default: '__underline_typography underline underline-offset-4 decoration-8',
	variants: {
		primary: 'decoration-primary-600',
		success: 'decoration-success-600',
		error: 'decoration-error-600',
		warning: 'decoration-warning-500'
	}
};

export const textStyles: ComponentStyle = {
	default: '__text_typography break-words antialiased',
	variants: {
		main: 'text-neutral-800',
		secondary: 'text-neutral-500',
		discrete: 'text-neutral-300',
		error: 'text-error-600',
		success: 'text-success-600',
		primary: 'text-primary-600',
		inherit: 'text-inherit',
		// Sizes
		sm: 'text-sm',
		xs: 'text-xs',
		base: 'text-base',
		lg: 'text-lg',
		xl: 'text-xl',

		// Line height
		normal: 'leading-normal',
		relaxed: 'leading-relaxed',
		loose: 'leading-loose',
		tight: 'leading-tight',
		snug: 'leading-snug',
		none: 'leading-none',
		// Text align
		center: 'text-center',
		right: 'text-right',
		left: 'text-left',
		//
		regular: 'font-regular',
		medium: 'font-medium',
		semibold: 'font-semibold',
		bold: 'font-bold'
	},
	states: {
		invert: 'text-white'
	}
};
